import { render, staticRenderFns } from "./metta-store.vue?vue&type=template&id=196b1b9e&scoped=true"
import script from "./metta-store.vue?vue&type=script&lang=js"
export * from "./metta-store.vue?vue&type=script&lang=js"
import style0 from "./metta-store.vue?vue&type=style&index=0&id=196b1b9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b1b9e",
  null
  
)

export default component.exports